import React from "react";
import Table from "../Table";
import moment from "moment";

function UsersTable(props) {
  const title = "Manage Users";
  const columns = [
    {
      name: "Login Name",
      selector: "username",
      sortable: true,
      ignoreRowClick: true
    },
    {
      name: "Name",
      sortable: true,
      selector: "fname",
      ignoreRowClick: true,
      cell: row => {
        return (
          <div>
            <span className="nameLabel">
              {row.fname !== "undefined" ? row.fname : ""}
            </span>
            <span>&nbsp;</span>
            <span className="nameLabel">
              {row.lname !== "undefined" ? row.lname : ""}
            </span>
          </div>
        );
      }
    },
    {
      name: "Role",
      selector: true,
      sortable: true,
      selector: "role",
      ignoreRowClick: true,
      cell: row => {
        return (() => {
          switch (row.role) {
            case "sadmin":
              return <span>Yodlee Super Administrator</span>;
            case "admin":
              return <span>Yodlee Administrator</span>;
            case "lender":
              return <span>Lender Administrator</span>;
            case "srep":
              return <span>Yodlee Service Representative</span>;
            case "cadmin":
              return <span>Client Administrator</span>;
            case "csrep":
              return <span>Client Service Representative</span>;
            case "yint":
              return <span>Yodlee Internal User</span>;
            case "ycc":
              return <span>Yodlee Customer Service</span>;
            case "demo":
              return <span>Demo User </span>;
            case "borrower":
              return <span>Applicant</span>;
            default:
              return <span></span>;
          }
        })();
      }
    },
    {
      name: "Created Date",
      selector: "lastUpdated",
      sortable: true,
      ignoreRowClick: true,
      cell: row => {
        return (
          <span>
            {moment
              .utc(row.lastUpdated)
              .local()
              .format("MM-DD-YYYY HH:mm")}
          </span>
        );
      }
    }
  ];
  return (
    <Table
      title={title}
      columns={columns}
      data={props.data}
      pagination={true}
      paginationPerPage={props.paginationPerPage}
      paginationRowsPerPageOptions={[25, 50, 75, 100]}
    />
  );
}

export default UsersTable;
